<template>
  <div class="poster-container">
    <!--    <div class="contaner" ref="imageWrapper">-->
    <!--      <div class="user-info">-->
    <!--        <img src="../../assets/imgs/readLog.jpeg" alt="" class="user-head">-->
    <!--        <div class="name">-->
    <!--          <p class="nick-name">张三</p>-->
    <!--          <p class="desc">邀请你加入</p>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <img src="../../assets/imgs/readLog.jpeg" alt="" class="ercode">-->
    <!--      &lt;!&ndash;    生成的图片&ndash;&gt;-->
    <!--      <img class="cover-img" :src="posterImageUrl" alt="">-->
    <!--    </div>-->
    <img class="cover-img" :src="posterImageUrl" alt="" crossOrigin="anonymous"/>

    <!--    分享指引-->
    <div v-show="shareGuide" class="share-guide">
      <div class="share-guide-content">
        <img class="share-guide-img" :src="require('../../assets/imgs/dailyShare/haibao_longpush.png')" @click="shareGuide=false"/>
        <p class="share-guide-text">长按下方海报可发送好友</p>
      </div>
      <div class="share-guide-bg" @click="shareGuide=false"></div>
    </div>

    <van-loading v-show="showLoading" :vertical="true" size="24px" color="#fff" class="haibao-loading">正在生成海报...</van-loading>
  </div>
</template>

<script>
  import {
    getFindWeChatHelpQrcode
  } from "@/api/share";

  export default {
    name: "PosterPage",
    props: {
      // audioId: {
      //   type: String
      // }
    },

    data() {
      return {
        posterImageUrl: '',
        // userPhoto: '',
        showLoading: false,
        shareGuide: false,
      }
    },

    activated() {
      //重置进入页面的状态
      this.posterImageUrl = '';
      this.showLoading = false;
      this.shareGuide = false;

      this.request_getFindWeChatHelpQrcode()
    },

    computed: {
      // photo() {
      //   let phone64 = 'data:image/jpeg;base64,' + this.$store.state.userInfo.headImgUrlBase64;
      //   const img = require('@/assets/imgs/readLog.jpeg')
      //   return this.$store.state.userInfo.headImgUrlBase64 ? phone64 : img
      // },
      // nickName() {
      //   return this.$store.state.userInfo.nickname
      // }
    },

    components: {},

    mounted() {
      //生成二维码
      // this.creatErcode()
      // setTimeout(() => {
      //   this.creatPoster()
      // }, 500)
      // location.replace(location.href)
    },

    methods: {
      //获取海报
      request_getFindWeChatHelpQrcode() {
        let params = {childUserId: this.$route.query.childUserId,shareSource: this.$route.query.shareSource}
        if (this.$route.query.childUserId) {
          params['whetherFamilyHelpChild'] = true;
        }else {
          params['whetherFamilyHelpChild'] = false;
        }
        this.showLoading = true
        getFindWeChatHelpQrcode(params).then(res => {
          this.showLoading = false
          if (res.code == 0) {
            //将海报展示给用户
            // let phone64 = 'data:image/jpeg;base64,' + this.$store.state.userInfo.headImgUrlBase64;
            this.posterImageUrl = 'data:image/jpg;base64,' + res.data.helpThePosterBase64;
            // this.posterImageUrl = encodeURIComponent('https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1592565057771&di=e1c27fde9a1804541baf498dfba9fd72&imgtype=0&src=http%3A%2F%2Ft7.baidu.com%2Fit%2Fu%3D2789097066%2C2241155970%26fm%3D79%26app%3D86%26f%3DJPEG%3Fw%3D1280%26h%3D959')
            // this.$toast({
            //   message: '长按发送给好友',
            //   duration: 2000
            // })
            this.shareGuide = true
          } else {
            this.$toast({
              message: res.msg,
              duration: 1000
            })
          }
        })
      },

      // creatPoster() {
      //   const options = {
      //     backgroundColor: null,
      //     useCORS: true,
      //     allowTaint: false
      //   }
      //   html2canvas(this.$refs.imageWrapper, options).then((canvas) => {
      //     let dataURL = canvas.toDataURL("image/png")
      //     this.posterImageUrl = dataURL
      //   })
      // },

      //生成二维码
      // creatErcode() {
        // let shareUrl = this.$route.query.shareUrl;
        // QRCode.toCanvas(
        //   this.$refs.canvass,
        //   shareUrl,
        //   function(error) {
        //     if (error) console.error(error);
        //     console.log("success!");
        //   }
        // );
      // },
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import "../stylesheet/common.styl"
  .poster-container {
    min-height: 100vh;
    background-color: #fff;
    box-sizing: border-box;
  }

  .contaner {
    position: relative;
    width: 100vw;
    height: calc(100vw * 3549 / 2000);
    background-size: 100vw calc(100vw * 3549 / 2000 + 20px);
    padding: 20px 24px 0;
    transform: scale(0.8, 0.8)
  }

  .ercode {
    position: absolute;
    width: 80px;
    height: 80px;
    right: 64px;
    bottom: 10px;
  }

  //上方用户信息
  .user-info
    display: flex
    align-items: center

    .user-head
      width: 40px
      height: 40px
      border-radius: 50px

    .name
      flex: 1
      padding: 0 8px
      color: #000

  .cover-img
    position: absolute
    top: 0
    left: 0
    width: 100%

  .haibao-loading{
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 50%;
    top: 50%;
    padding: 10px 10px;
    transform: translateX(-50%) translateY(-50%);
  }

  .van-loading__text{
    color: #fff;
  }

  //分享指引
  .share-guide {
    position: relative;
    .share-guide-content{
      position: fixed;
      left: 50%;
      top: 40%;
      transform: translate(-50%, -50%);
      z-index: 1000;
      text-align: center;
    }
    .share-guide-img {
      display: inline-block;
      margin: 0 auto;
      width: 88px;
    }
    .share-guide-text {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }

    .share-guide-bg {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.4);
      z-index: 999;
    }
  }
</style>



// WEBPACK FOOTER //
// app/pages/share/FreeHaibao.vue